import { supabase } from '@/integrations/supabase/client';

/**
 * Build headers for edge-function calls that require a valid user JWT.
 * Uses refreshSession() first to guarantee a fresh access token —
 * critical on iOS Safari where cached sessions go stale quickly.
 * Falls back to the anon key when no session exists.
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
  // refreshSession() returns a fresh token even if the cached one expired.
  // This prevents silent 401s on iOS Safari where storage is aggressively evicted.
  let accessToken: string | undefined;

  try {
    const { data: refreshData } = await (supabase.auth as any).refreshSession();
    accessToken = refreshData?.session?.access_token;
  } catch {
    // refreshSession can throw on network errors; fall back to cached session
  }

  if (!accessToken) {
    const { data } = await (supabase.auth as any).getSession();
    accessToken = data?.session?.access_token;
  }

  return {
    'Content-Type': 'application/json',
    'apikey': import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    'Authorization': `Bearer ${accessToken ?? import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY}`,
  };
}
